<template>
    <div v-if="result.hotel.rating" class="star-rating">
        <svg v-for="index in parseInt(result.hotel.rating)" :key="index" class="star" xmlns="http://www.w3.org/2000/svg" focusable="false" tabindex="-1" width="12" height="12" viewBox="0 0 12 12"><path class="svg-color--primary" fill="#F6AB3F" d="M11.988 5.21a.667.667 0 00-.545-.534l-3.604-.6L6.63.455a.666.666 0 00-1.262.001L4.16 4.076l-3.603.6a.667.667 0 00-.233 1.228L3.2 7.63l-1.165 3.493a.67.67 0 00.25.758.672.672 0 00.798-.026L6 9.52l2.917 2.333a.66.66 0 00.796.027.665.665 0 00.252-.758L8.8 7.63l2.876-1.725a.667.667 0 00.312-.696z"></path></svg>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { 
        faStar
    }  from '@fortawesome/free-solid-svg-icons'

    library.add(faStar)

    export default {
        name: 'StarRating',
        props: {
            result: {
                type: Object,
                required: true
            },
        }
    }
</script>

<style scoped>
    .star{
        margin-right:1px;
    }
</style>
